<template>
  <RevIllustration
    src="/mine-my-phone/icons/video--flat.svg"
    :width="26"
    :height="26"
    alt=""
    aria-hidden="true"
  />
</template>

<script setup lang="ts">
import { RevIllustration } from '@ds/components/Illustration'
</script>
